import * as React from "react";

import { createBrowserRouter } from "react-router-dom";

import { AboutPage } from "./components/pages/AboutPage";
import { EditorPage } from "./components/pages/EditorPage";
import { HomePage } from "./components/pages/HomePage";
import { ManagePage } from "./components/pages/ManagePage";
import { PageStructure } from "./components/pages/PageStructure";
import { ReportABugPage } from "./components/pages/ReportABugPage";
import { ShareImportPage } from "./components/pages/ShareImportPage";
import { TemplateGalleryPage } from "./components/pages/TemplateGalleryPage";
import { TemplateInfoPage } from "./components/pages/TemplateInfoPage";
import { WhatsNewPage } from "./components/pages/WhatsNewPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <PageStructure />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "editor",
        element: <EditorPage />,
      },
      {
        path: "manage",
        element: <ManagePage />,
      },
      {
        path: "shared/:shareId",
        element: <ShareImportPage />,
      },
      {
        path: "templates",
        element: <TemplateGalleryPage />,
      },
      {
        path: "templates/aircraft/:addonId",
        element: <TemplateInfoPage type="aircraft" />,
      },
      {
        path: "templates/software/:addonId",
        element: <TemplateInfoPage type="addon" />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "updates",
        element: <WhatsNewPage />,
      },
      {
        path: 'report-a-bug',
        element: <ReportABugPage />,
      }
    ],
  },
]);
